"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Menu, X, ZapIcon } from "lucide-react";
import { DashboardButton } from "@/components/app/dashboard-button";
import { Button } from "@/components/ui/button";
export function SiteHeader() {
  const $ = _c(23);
  const [isOpen, setIsOpen] = useState(false);
  let t0;
  if ($[0] !== isOpen) {
    t0 = () => setIsOpen(!isOpen);
    $[0] = isOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== isOpen) {
    t1 = isOpen ? <X className="size-5" /> : <Menu className="size-5" />;
    $[2] = isOpen;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <Button variant="ghost" size="icon" className="-ml-2 h-9 w-9 md:hidden" onClick={t0} aria-label="Toggle menu">{t1}</Button>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <a href="#home" className="flex items-center gap-2 tracking-tight rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"><ZapIcon className="size-5 md:size-7 shrink-0" strokeWidth={1.5} aria-hidden="true" /><span className="font-semibold">supadmin</span></a>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2) {
    t4 = <div className="flex items-center gap-2">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex items-center md:hidden"><DashboardButton /></div>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4) {
    t6 = <div className="flex h-14 items-center justify-between px-4 md:h-auto md:px-0">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = `${isOpen ? "flex" : "hidden"} flex-col border-t px-4 py-4 md:flex md:flex-row md:items-center md:border-none md:p-0`;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <a href="#how-it-works" onClick={() => setIsOpen(false)} className="rounded-md md:rounded-full px-3 py-2 hover:bg-gray-100 hover:text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 transition-all">How it works</a>;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <a href="#features" onClick={() => setIsOpen(false)} className="rounded-md md:rounded-full px-3 py-2 hover:bg-gray-100 hover:text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 transition-all">Features</a>;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <a href="#pricing" onClick={() => setIsOpen(false)} className="rounded-md md:rounded-full px-3 py-2 hover:bg-gray-100 hover:text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 transition-all">Pricing</a>;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <nav className="flex flex-col md:flex-row md:items-center md:justify-center">{t8}{t9}{t10}{" "}<a href="#faq" onClick={() => setIsOpen(false)} className="rounded-md md:rounded-full px-3 py-2 hover:bg-gray-100 hover:text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 transition-all">FAQ</a></nav>;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t7) {
    t12 = <div className={t7}>{t11}</div>;
    $[17] = t7;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="hidden md:block"><DashboardButton /></div>;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t12 || $[21] !== t6) {
    t14 = <header className="relative z-50 w-full border-b bg-white/85 backdrop-blur md:border-none md:bg-transparent md:px-12 md:pt-10 md:backdrop-blur-none"><div className="mx-auto flex w-full max-w-4xl flex-col md:flex-row md:items-center md:justify-between md:rounded-full md:corner-squircle md:border md:bg-white/85 md:px-6 md:py-3 md:backdrop-blur">{t6}{t12}{t13}</div></header>;
    $[20] = t12;
    $[21] = t6;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  return t14;
}